import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import CardBillAccountInfoPopup from './card-bill-account-info-popup';
import CardBillListStore from './card-bill-list-store';
import CusEntInfoStore from '../corp-info/corp-info-store';

const CardBillAccountInfoPopupContainer = () => {
  // console.log('CardBillAccountInfoPopupContainer Load');

  const { visibleAccountInfoPopup } = CardBillListStore;
  const [ accountInfo, setAccountInfo ] = useState();
  const { cusEntInfo } = CusEntInfoStore;
  const { bankList } = CardBillListStore;
  const [notifyMsg, setNotifyMsg] = useState();

  useEffect(() => {
    // console.log('CardBillAccountInfoPopupContainer > useEffect()');

    if (visibleAccountInfoPopup) {
        setAccountInfo({
            bankCode: cusEntInfo.BankCode,
            bankName: cusEntInfo.BankName,
            accountNo: cusEntInfo.AccountNo,
            bankOwnerName: cusEntInfo.BankOwnerName,
        });
    }
    CardBillListStore.getBankList();
    // console.log(bankList)
  }, [ visibleAccountInfoPopup, cusEntInfo ]);

  const onValueChanged = useCallback((name, e) => {
    const { value } = e;
    
    setAccountInfo((accountInfo) => ({
        ...accountInfo,
        [name]: value,
      }));
  }, []);

  const onClickSave = useCallback(async () => {
    if (accountInfo.bankCode == '') {
      setNotifyMsg('은행을 선택해주세요.');
    }
    else if (accountInfo.accountNo == '') {
      setNotifyMsg('계좌번호를 입력해주세요.');
    }
    else if (accountInfo.bankOwnerName == '') {
      setNotifyMsg('예금주를 입력해주세요.');
    }
    else {
      const result = await CardBillListStore.updateCusEntAccountInfo(
        accountInfo,
      );

      if (result.error) {
          alert(result.message);
          setNotifyMsg(result.message);
      } else {
          alert(result.message);
          CardBillListStore.setVisibleAccountInfoPopup(false);
          CusEntInfoStore.getCusEntInfo();
          setNotifyMsg('');
      }
    }
  }, [accountInfo]);

  if (!cusEntInfo) {
    return;
  }

  if (!accountInfo) {
    return;
  }

  return (
    <CardBillAccountInfoPopup
      onValueChanged={onValueChanged}
      onClickSave={onClickSave}
      onHiding={() => CardBillListStore.setVisibleAccountInfoPopup(false)}
      accountInfo={accountInfo}
      bankList={bankList}
      visibleAccountInfoPopup={visibleAccountInfoPopup}
      notifyMsg={notifyMsg}
    />
  );
};

export default React.memo(observer(CardBillAccountInfoPopupContainer));